import React, {useEffect, useState} from "react";
import MUIDataTable from "mui-datatables";
import Loader from "../../Loader";
// import moment from "moment";
import { GetLogs } from "../../Redux/Actions/userStatusService";
import { useDispatch } from "react-redux";

const ActivityTable = () => {
 
  const userInfoString = localStorage.getItem("userInfo");
  const userInfo = userInfoString && userInfoString !== "undefined" ? JSON.parse(userInfoString) : null;
  const role = userInfo?.portal || 'MANAGER';
  const id = userInfo?.id || null; 
  const dispatch= useDispatch()
 
  const [ActivityValue, setActivityValue] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPortal = async () => {
      try {
        const response = await dispatch(GetLogs({role, id}));
        setActivityValue(response.payload.data); 
      } catch (error) {
        console.error("Error fetching portal:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPortal();
  }, []);

 
  const columns = [
    {
      name: "serviceName",
      label: "Service Name",
      options: {
        filter: true,
      },
    },
    {
      name: "reason",
      label: "Reason",
      options: {
        filter: true,
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
      },
    },
    {
      name: "createdAt",
      label: "Created At",
      options: {
        filter: true,
        customBodyRender: (value) => {
          return new Date(value).toLocaleString(); // Format date
        },
      },
    },
  ];

  const options = {
    filter: true,
    responsive: "standard",
    selectableRows: "none",
    rowsPerPage: 9, 
    pagination: true,
  };
  
  return (
    <>
    {loading ? (
      <Loader /> // Show loader while fetching data
    ) : (
      <MUIDataTable
        title={"Activity Logs"}
        data={ActivityValue.map(log => ({
          serviceName: log.methodName,
          reason: log.reason,
          status: log.status,
          createdAt: log.createdAt,
        }))}
        columns={columns}
        options={options}
      />
    )}
  </>
  );  
};

export default ActivityTable;

